export function validateMCForm( e ) {

    // document.getElementById( 'mc-embedded-subscribe-form' ).addEventListener( 'submit', function ( e ) {

    const firstName = document.forms[ 'mc-embedded-subscribe-form' ][ 'FNAME' ].value.trim();

    const lastName = document.forms[ 'mc-embedded-subscribe-form' ][ 'LNAME' ].value.trim();

    const email = document.forms[ 'mc-embedded-subscribe-form' ][ 'EMAIL' ].value;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    let valid = true;

    var errorMessages = document.querySelector( 'form' ).querySelectorAll( '.input-error-message' );

    for ( var i = 0; i < errorMessages.length; i++ ) {

        errorMessages[ i ].parentNode.removeChild( errorMessages[ i ] );

    }

    if ( firstName === '' ) {

        const firstNameContainer = document.getElementById( 'required-FNAME' );

        const fnNode = document.createElement( 'div' );

        fnNode.classList.add( 'input-error-message' );
        const fnTextNode = document.createTextNode( 'This field is required.' );

        fnNode.appendChild( fnTextNode );
        firstNameContainer.appendChild( fnNode );

        valid = false;

    }

    if ( lastName === '' ) {

        const lastNameContainer = document.getElementById( 'required-LNAME' );

        const lnNode = document.createElement( 'div' );

        lnNode.classList.add( 'input-error-message' );
        const lnTextNode = document.createTextNode( 'This field is required.' );

        lnNode.appendChild( lnTextNode );
        lastNameContainer.appendChild( lnNode );

        valid = false;

    }

    if ( email.trim() === '' || !email.match( emailPattern ) ) {

        const emailContainer = document.getElementById( 'required-EMAIL' );

        const emailNode = document.createElement( 'div' );

        emailNode.classList.add( 'input-error-message' );

        let emailTextNode = null;

        if ( email.trim() === '' ) {

            emailTextNode = document.createTextNode( 'This field is required.' );

        }
        else {

            emailTextNode = document.createTextNode( 'Please enter a valid email address.' );

        }

        emailNode.appendChild( emailTextNode );
        emailContainer.appendChild( emailNode );

        valid = false;

    }

    var invalidFields = document.querySelector( 'form' ).querySelectorAll( '.input-error-message' );

    if ( invalidFields.length > 0 ) {

        invalidFields[ 0 ].parentNode.focus();
        invalidFields[ 0 ].parentNode.scrollIntoView();

    }

    if ( !valid ) {

        e.preventDefault();

    }

    return valid;

    // } );

}
